import React from "react";

const SupportPage = () => {
    return (
        <div style={styles.container}>
            <h1 style={styles.heading}>Support</h1>
            <p style={styles.introText}>
                Need help? We’re here to assist you. Check out the frequently asked questions below or contact us directly.
            </p>

            <section style={styles.section}>
                <h2 style={styles.sectionHeading}>Frequently Asked Questions</h2>

                <div style={styles.faqItem}>
                    <h3 style={styles.question}>How do I make a booking?</h3>
                    <p style={styles.answer}>
                        You can make a booking through our app by selecting the car you want, and confirming your booking.
                    </p>
                </div>

                <div style={styles.faqItem}>
                    <h3 style={styles.question}>How do I cancel a booking?</h3>
                    <p style={styles.answer}>
                        To cancel a booking, go to your bookings section, select the booking you wish to cancel, and click the "Cancel" option. Cancellation policies may apply.
                    </p>
                </div>
            </section>

            <section style={styles.section}>
                <h2 style={styles.sectionHeading}>Contact Support</h2>
                <p style={styles.text}>
                    If your question isn’t answered above, please reach out to our support team. We’re available to assist you with any issues.
                </p>
                <p style={styles.text}>
                    Email us at <a href="mailto:support@example.com" style={styles.emailLink}>support@vertex.com</a>
                </p>
            </section>

            <section style={styles.section}>
                <h2 style={styles.sectionHeading}>Helpful Links</h2>
                <ul style={styles.linkList}>
                    <li><a href="/admin/privacy" style={styles.link}>Privacy Policy</a></li>        </ul>
            </section>
        </div>
    );
};

const styles = {
    container: {
        fontFamily: "'Arial', sans-serif",
        padding: "20px",
        maxWidth: "800px",
        margin: "0 auto",
        backgroundColor: "#f9f9f9",
        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
    },
    heading: {
        fontSize: "2rem",
        color: "#333",
        textAlign: "center",
    },
    introText: {
        fontSize: "1.1rem",
        color: "#555",
        marginBottom: "20px",
        lineHeight: "1.6",
    },
    section: {
        marginBottom: "20px",
    },
    sectionHeading: {
        fontSize: "1.5rem",
        color: "#222",
        borderBottom: "2px solid #ddd",
        paddingBottom: "5px",
        marginBottom: "10px",
    },
    faqItem: {
        marginBottom: "15px",
    },
    question: {
        fontSize: "1.2rem",
        fontWeight: "bold",
        color: "#333",
    },
    answer: {
        fontSize: "1rem",
        color: "#555",
        lineHeight: "1.6",
    },
    text: {
        fontSize: "1rem",
        color: "#555",
        lineHeight: "1.6",
    },
    emailLink: {
        color: "#007bff",
        textDecoration: "none",
    },
    linkList: {
        listStyleType: "none",
        padding: "0",
    },
    link: {
        color: "#007bff",
        textDecoration: "none",
        display: "block",
        padding: "5px 0",
    }
};

export default SupportPage;
